import { useTranslation } from "react-i18next";
import { ClickableText } from "../../../common/components/Typography";
import { Box, Dot } from "../../../common/components";
import { palette } from "../../../styles/theme";
import { Typography } from "@mui/material";
import sparkling from "../../../assets/images/sparkling_2.svg";
import { ItemPricing } from "../../../types";
import { ProductList } from "../../../constant/common.constant";
import { useThemeBreakpoints } from "../../../utils/themeUtils";

interface Props {
  onRemove: () => void;
  onRecommendSizesClick: () => void;
  showRecommendSizes?: boolean;
  item: ItemPricing;
}

const CartItemAction = ({
  onRemove,
  onRecommendSizesClick,
  showRecommendSizes,
  item,
}: Props) => {
  const { t, i18n } = useTranslation();
  const { isMobile } = useThemeBreakpoints();
  const sizeChartUrl = ProductList.find(
    (product) => product.product.name === item.productName
  )?.sizeChartUrl;
  return (
    <Box
      display={"flex"}
      alignItems={{ xs: "flex-start", lg: "center" }}
      gap={{ xs: "12px", lg: "4px" }}
      fullWidth
      flexDirection={{ xs: "column", lg: "row" }}
      mt={{ xs: "12px", lg: "0px" }}
    >
      {showRecommendSizes && (
        <>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
              cursor: "pointer",
            }}
            onClick={onRecommendSizesClick}
          >
            <img src={sparkling} alt="recommend-sizes" />
            <Typography
              variant="textSm"
              maxWidth={"fit-content"}
              data-test="cartItem.recommendSizes"
              sx={{
                background: "linear-gradient(90deg, #54ACDE 0%, #A954DE 100%)",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                fontWeight: 500,
              }}
            >
              {t("cart.recommend_sizes.title")}
            </Typography>
          </Box>
          {!isMobile && <Dot color={palette.grey.darkGrey} size={3} />}
        </>
      )}
      {sizeChartUrl?.[i18n.language as keyof typeof sizeChartUrl] && (
        <>
          <ClickableText
            variant="textSm"
            onClick={() => {
              window.open(
                sizeChartUrl?.[i18n.language as keyof typeof sizeChartUrl],
                "_blank"
              );
            }}
            maxWidth={"fit-content"}
            data-test="cartItem.sizeChart"
          >
            {t("cart.size_chart")}
          </ClickableText>
          {!isMobile && <Dot color={palette.grey.darkGrey} size={3} />}
        </>
      )}
      <ClickableText
        variant="textSm"
        onClick={() => onRemove()}
        maxWidth={"fit-content"}
        data-test="cartItem.remove"
      >
        {t("cart.remove")}
      </ClickableText>
    </Box>
  );
};

export default CartItemAction;
